import styled from 'styled-components';
import { layers, layout, colors } from '../../theme';

export const Wrapper = styled.div`
  background: ${colors.WHITE};
  border-radius: ${layout.SPACING}rem;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
  color: ${colors.BLACK};
  /* mix-blend-mode: difference; */
  padding: ${layout.SPACING / 3}rem ${layout.SPACING / 2}rem;
  pointer-events: none;
  position: fixed;
  /* width: 100rem; */
  transform: translate3d(${`${layout.SPACING / 2}rem`}, -100%, 0);
  z-index: ${layers.CURSOR};
`;
